import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/** Notifies Gruppen dashboard when an import-tierliste was persisted (HTTP 200). */
@Injectable({ providedIn: 'root' })
export class GruppenDashboardImportRefreshService {
    private readonly importCompleted$ = new Subject<number>();

    readonly onImportCompleted = this.importCompleted$.asObservable();

    notifyImportCompleted(tierlisteId: number): void {
        if (tierlisteId > 0) {
            this.importCompleted$.next(tierlisteId);
        }
    }
}
